import React, { useContext } from "react";
import type { CSSProperties, MouseEvent, ReactElement, ReactNode } from "react";
import PropTypes from "prop-types";
import type { FormAction } from "./types";
import { FormContext } from "./";

type ActionProps = {
  children?: ReactNode;
  dangerouslyDisableShowLoading?: boolean;
  // Other action options are forwarded unchanged to the form's submit handler.
  [key: string]: unknown;
};

type ActionBarProps = {
  children?: ReactNode;
  style?: CSSProperties;
  vertical?: boolean;
};

const Action = ({
  children,
  // Setting this property to true will disable the multiple click prevention that the loading state provides.
  dangerouslyDisableShowLoading = false,
  ...actionProps
}: ActionProps) => {
  const { onSubmit } = useContext(FormContext)!;

  actionProps.dangerouslyDisableShowLoading = dangerouslyDisableShowLoading;

  const onClick = (e: MouseEvent) => {
    onSubmit(actionProps as FormAction, e);
  };
  return (
    <>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child as ReactElement<{ onClick: typeof onClick }>, {
          onClick,
        });
      })}
    </>
  );
};

Action.propTypes = {
  children: PropTypes.node,
  dangerouslyDisableShowLoading: PropTypes.bool,
};

const VERTICAL_STYLES: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  marginTop: "40px",
  alignItems: "center",
};
export const ActionBar = ({
  children,
  style: styleProps = {
    display: "flex",
    flexDirection: "row",
    marginTop: "40px",
  },
  vertical = false,
}: ActionBarProps) => {
  const style = {
    ...styleProps,
    ...(vertical ? VERTICAL_STYLES : undefined),
  };
  return (
    <div className="action-bar" style={style}>
      {children}
    </div>
  );
};
ActionBar.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
  vertical: PropTypes.bool,
};

export default Action;
